
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
  @Prop() private visible!: boolean;
  @Prop() private title!: string;
  @Prop() private bg!: string;
  @Emit() private close() {}
  mounted() {}
}
